const color = [
  "primary",
  "status-green",
  "status-red",
  "status-yellow",
  "status-orange",
  "status-gray",
  "status-blue",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle"
] as const

export default {
  "slots": {
    "root": "relative overflow-hidden w-full rounded-lg p-4 flex gap-2.5",
    "wrapper": "min-w-0 flex-1 flex flex-col",
    "title": "text-sm font-medium",
    "description": "text-sm opacity-90",
    "icon": "shrink-0 size-5",
    "avatar": "shrink-0",
    "avatarSize": "2xl",
    "actions": "flex flex-wrap gap-1.5 shrink-0",
    "close": "p-0"
  },
  "variants": {
    "color": {
      "primary": "",
      "status-green": "",
      "status-red": "",
      "status-yellow": "",
      "status-orange": "",
      "status-gray": "",
      "status-blue": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": ""
    },
    "orientation": {
      "horizontal": {
        "root": "items-center",
        "actions": "items-center"
      },
      "vertical": {
        "root": "items-start",
        "actions": "items-start mt-2.5"
      }
    },
    "title": {
      "true": {
        "description": "mt-1"
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-primary text-inverted"
      }
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-status-green text-inverted"
      }
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-status-red text-inverted"
      }
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-status-yellow text-inverted"
      }
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-status-orange text-inverted"
      }
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-status-gray text-inverted"
      }
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-status-blue text-inverted"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-secondary text-inverted"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-success text-inverted"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-info text-inverted"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-warning text-inverted"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "bg-error text-inverted"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-primary ring ring-inset ring-primary/25"
      }
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-status-green ring ring-inset ring-status-green/25"
      }
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-status-red ring ring-inset ring-status-red/25"
      }
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-status-yellow ring ring-inset ring-status-yellow/25"
      }
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-status-orange ring ring-inset ring-status-orange/25"
      }
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-status-gray ring ring-inset ring-status-gray/25"
      }
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-status-blue ring ring-inset ring-status-blue/25"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-secondary ring ring-inset ring-secondary/25"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-success ring ring-inset ring-success/25"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-info ring ring-inset ring-info/25"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-warning ring ring-inset ring-warning/25"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-error ring ring-inset ring-error/25"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-primary/10 text-primary"
      }
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-status-green/10 text-status-green"
      }
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-status-red/10 text-status-red"
      }
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-status-yellow/10 text-status-yellow"
      }
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-status-orange/10 text-status-orange"
      }
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-status-gray/10 text-status-gray"
      }
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-status-blue/10 text-status-blue"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-secondary/10 text-secondary"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-success/10 text-success"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-info/10 text-info"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-warning/10 text-warning"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "bg-error/10 text-error"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-primary/10 text-primary ring ring-inset ring-primary/25"
      }
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-status-green/10 text-status-green ring ring-inset ring-status-green/25"
      }
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-status-red/10 text-status-red ring ring-inset ring-status-red/25"
      }
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-status-yellow/10 text-status-yellow ring ring-inset ring-status-yellow/25"
      }
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-status-orange/10 text-status-orange ring ring-inset ring-status-orange/25"
      }
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-status-gray/10 text-status-gray ring ring-inset ring-status-gray/25"
      }
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-status-blue/10 text-status-blue ring ring-inset ring-status-blue/25"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-secondary/10 text-secondary ring ring-inset ring-secondary/25"
      }
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-success/10 text-success ring ring-inset ring-success/25"
      }
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-info/10 text-info ring ring-inset ring-info/25"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-warning/10 text-warning ring ring-inset ring-warning/25"
      }
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "bg-error/10 text-error ring ring-inset ring-error/25"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": {
        "root": "text-inverted bg-inverted"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": {
        "root": "text-highlighted bg-default ring ring-inset ring-default"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": {
        "root": "text-highlighted bg-elevated/50"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": {
        "root": "text-highlighted bg-elevated/50 ring ring-inset ring-accented"
      }
    }
  ],
  "defaultVariants": {
    "color": "primary" as typeof color[number],
    "variant": "solid" as typeof variant[number]
  }
}